import { IMG } from "./site";

// Unique, non-duplicated content for every city we serve.
export const LOCATIONS_DATA = [
  {
    slug: "prescott",
    name: "Prescott",
    primary: true,
    image: IMG.blackGarage,
    intro: [
      "Prescott is our home base, and we treat every floor here like it belongs to a neighbor — because it usually does. From the historic homes near Whiskey Row to newer builds out by Granite Mountain, we know Prescott concrete and what it takes to coat it right.",
      "At a mile high, Prescott sees cold winters, summer monsoons and big temperature swings. That's hard on garage slabs, which is exactly why proper grinding and premium polyaspartic coatings matter so much here.",
    ],
    conditions: "Many Prescott garages have older slabs with surface cracks, oil stains and hot-tire wear. We grind, repair and coat them so they look brand new and stay that way.",
    landmarks: ["Whiskey Row", "Watson Lake", "Granite Mountain", "Thumb Butte"],
    faqs: [
      { q: "Do you serve all of Prescott?", a: "Yes — from downtown and the historic district out to Granite Mountain, Williamson Valley and everywhere in between." },
      { q: "Can you handle cracked older slabs?", a: "Definitely. Older Prescott garages often need crack repair first. We fill cracks with structural polyurea before coating." },
    ],
  },
  {
    slug: "flagstaff",
    name: "Flagstaff",
    primary: true,
    image: IMG.hexLed,
    intro: [
      "Flagstaff sits at 7,000 feet, so floors here face heavy snow, freezing temperatures and plenty of road salt. We install coatings engineered to handle that punishment without cracking or peeling.",
      "Whether you're near downtown, NAU or out along Route 66, we bring the same careful prep and premium materials to every Flagstaff garage and commercial floor.",
    ],
    conditions: "Snow, ice melt and freeze-thaw cycles are tough on Flagstaff concrete. Salt-laden slush eats away at unsealed slabs, so a properly bonded coating makes a real difference.",
    landmarks: ["Downtown Flagstaff", "Northern Arizona University", "Route 66", "San Francisco Peaks"],
    faqs: [
      { q: "Will road salt damage my coating?", a: "Our polyaspartic coatings resist salt and ice melt. They protect the concrete underneath from the damage salt usually causes." },
      { q: "Do you coat commercial floors in Flagstaff?", a: "Yes. We do warehouses, shops and retail floors built for high traffic and cold-weather durability." },
    ],
  },
  {
    slug: "sedona",
    name: "Sedona",
    primary: true,
    image: IMG.metallic,
    intro: [
      "Sedona's red rock setting calls for floors that look as good as the views. We're known here for premium metallic garage finishes and beautiful, UV-stable patio coatings that hold up to the intense sun.",
      "From homes in Uptown to properties along Oak Creek, we deliver high-end, custom results with the same honest service we give every customer.",
    ],
    conditions: "Sedona's strong year-round sun fades cheap coatings fast. Our UV-stable polyaspartic systems keep their color and shine outdoors for years.",
    landmarks: ["Uptown Sedona", "Oak Creek", "Red Rock State Park", "Cathedral Rock"],
    faqs: [
      { q: "Do you do patio and pool deck coatings in Sedona?", a: "Yes, and they're popular here. Our UV-stable coatings won't yellow in the Sedona sun and add great curb appeal." },
      { q: "Can you match a high-end custom look?", a: "Absolutely. Our metallic and custom flake finishes are a perfect fit for Sedona's premium homes." },
    ],
  },
  {
    slug: "prescott-valley",
    name: "Prescott Valley",
    primary: false,
    image: IMG.blackGarage,
    intro: [
      "Prescott Valley is growing fast, and we coat floors in both established neighborhoods and brand-new builds. Newer garages still benefit from proper grinding so the coating bonds for life.",
      "We're just minutes away, which means quick scheduling and friendly local service for every Prescott Valley homeowner.",
    ],
    conditions: "Even new Prescott Valley slabs collect dust and hot-tire marks. A premium coating keeps your garage clean, bright and easy to maintain.",
    landmarks: ["StoneRidge", "Fain Park", "Glassford Hill"],
    faqs: [
      { q: "My garage is new — do I still need grinding?", a: "Yes. New concrete has a slick surface that coatings won't grip. Grinding opens the pores for a permanent bond." },
    ],
  },
  {
    slug: "chino-valley",
    name: "Chino Valley",
    primary: false,
    image: IMG.hexLed,
    intro: [
      "Chino Valley's larger lots mean bigger garages, shops and barns — and we love a good workshop floor. We coat them to handle tools, equipment and serious use.",
      "You get the same premium materials and careful prep here as anywhere, with honest pricing for the space you actually have.",
    ],
    conditions: "Shop and barn floors in Chino Valley take heavy abuse from equipment and dust. Durable coatings keep them clean and tough.",
    landmarks: ["Old Home Manor", "Peavine Trail", "Del Rio Springs"],
    faqs: [
      { q: "Can you coat a large shop or barn floor?", a: "Yes. We handle big residential shop floors and outbuildings with industrial-grade systems built for the work you do." },
    ],
  },
  {
    slug: "cottonwood",
    name: "Cottonwood",
    primary: false,
    image: IMG.metallic,
    intro: [
      "Down in the warmer Verde Valley, Cottonwood floors enjoy milder winters but still need protection from heat, stains and daily wear. We coat garages, patios and businesses throughout town.",
      "From Old Town to the newer subdivisions, we bring premium finishes and the same never-cut-corners standard to every job.",
    ],
    conditions: "Warmer Verde Valley temperatures and active lifestyles mean garage and patio floors see a lot of use. Our coatings keep them looking sharp.",
    landmarks: ["Old Town Cottonwood", "Verde River", "Dead Horse Ranch State Park"],
    faqs: [
      { q: "Do you serve Cottonwood businesses?", a: "Yes. We coat retail, shop and restaurant floors throughout Cottonwood and the Verde Valley." },
    ],
  },
  {
    slug: "camp-verde",
    name: "Camp Verde",
    primary: false,
    image: IMG.hexLed,
    intro: [
      "Camp Verde's hot summers and rural properties call for tough, easy-care floors. We coat home garages, shops and commercial spaces to stand up to heat and heavy use.",
      "We're happy to travel to Camp Verde and give you the same premium service we give every customer.",
    ],
    conditions: "Hot Verde Valley summers and dusty rural conditions are hard on bare concrete. A sealed, coated floor stays clean and cool to maintain.",
    landmarks: ["Fort Verde", "Verde River", "Montezuma Castle"],
    faqs: [
      { q: "Is it worth coating a rural shop floor?", a: "Yes. Coatings stop dusting, resist stains and make cleanup easy — a big help in a busy shop." },
    ],
  },
  {
    slug: "dewey-humboldt",
    name: "Dewey-Humboldt",
    primary: false,
    image: IMG.blackGarage,
    intro: [
      "Dewey-Humboldt's ranch properties and country garages are right in our backyard. We coat everything from two-car garages to large workshop floors.",
      "Local, quick to schedule and always honest — that's how we serve every Dewey-Humboldt homeowner.",
    ],
    conditions: "Ranch and rural garages here collect dust and take heavy equipment use. Durable coatings keep them clean and protected.",
    landmarks: ["Agua Fria River", "Highway 69 corridor"],
    faqs: [
      { q: "How soon can you get out to Dewey-Humboldt?", a: "Usually quickly — we're based nearby in Prescott, so scheduling is fast." },
    ],
  },
  {
    slug: "mayer",
    name: "Mayer",
    primary: false,
    image: IMG.metallic,
    intro: [
      "Mayer's small-town setting and country properties deserve big-city quality floors. We bring premium coatings and careful prep to garages and shops throughout the area.",
      "No job is too far. We're proud to serve Mayer with the same standards we hold everywhere.",
    ],
    conditions: "Older slabs and dusty conditions are common in Mayer. Grinding, repair and sealing bring tired concrete back to life.",
    landmarks: ["Big Bug Creek", "Highway 69"],
    faqs: [
      { q: "Do you travel to Mayer?", a: "Yes, we serve Mayer and the surrounding communities along the Highway 69 corridor." },
    ],
  },
  {
    slug: "williams",
    name: "Williams",
    primary: false,
    image: IMG.hexLed,
    intro: [
      "Known as the Gateway to the Grand Canyon, Williams sits high and cold with real winters. We install coatings that handle snow, freeze-thaw and Route 66 tourism traffic.",
      "Whether it's a home garage or a business floor, we coat it to last through tough mountain weather.",
    ],
    conditions: "High elevation means snow, ice melt and freezing temperatures. Properly bonded coatings protect Williams concrete from seasonal damage.",
    landmarks: ["Historic Route 66", "Bearizona", "Grand Canyon Railway"],
    faqs: [
      { q: "Can coatings handle Williams winters?", a: "Yes. Our polyaspartic systems stay flexible and resist salt and freeze-thaw, perfect for high-country garages." },
    ],
  },
  {
    slug: "kingman",
    name: "Kingman",
    primary: false,
    image: IMG.commercialWarehouse,
    intro: [
      "Kingman's desert heat and busy Route 66 corridor make durable, heat-resistant floors a must. We coat home garages and plenty of commercial and warehouse floors here.",
      "From the historic downtown to the industrial areas, we deliver tough coatings built for high heat and heavy traffic.",
    ],
    conditions: "Intense desert heat and warehouse traffic demand coatings that won't soften or wear through. Our industrial systems are made for it.",
    landmarks: ["Historic Route 66", "Hualapai Mountains", "Downtown Kingman"],
    faqs: [
      { q: "Will heat affect my coating?", a: "Our systems are heat-stable and resist hot-tire pickup, so they hold up well in Kingman's desert climate." },
    ],
  },
  {
    slug: "payson",
    name: "Payson",
    primary: false,
    image: IMG.roundRoom,
    intro: [
      "Up in the cool pines of Rim Country, Payson floors face mountain weather and cabin-country use. We coat garages, shops and patios to handle snow and seasonal swings.",
      "We're glad to bring premium coatings to Payson homeowners who want a floor that lasts.",
    ],
    conditions: "Snow and freeze-thaw cycles in Payson are hard on concrete. A bonded, flexible coating keeps slabs protected year-round.",
    landmarks: ["Mogollon Rim", "Green Valley Park", "Tonto Natural Bridge"],
    faqs: [
      { q: "Do you coat cabin and second-home garages?", a: "Yes. Durable coatings are a great low-maintenance choice for Payson cabins and weekend homes." },
    ],
  },
  {
    slug: "show-low",
    name: "Show Low",
    primary: false,
    image: IMG.hexLed,
    intro: [
      "Show Low and the White Mountains see cold winters and real snow, so floors here need coatings that won't crack in the freeze. We install systems built for high-country durability.",
      "From home garages to commercial floors, we bring the same premium quality to the White Mountains.",
    ],
    conditions: "Cold White Mountain winters and snow melt are tough on bare concrete. Our coatings flex with the temperature and resist salt damage.",
    landmarks: ["Fool Hollow Lake", "Pinetop-Lakeside", "White Mountains"],
    faqs: [
      { q: "Can coatings survive Show Low snow?", a: "Yes. We use flexible, salt-resistant polyaspartic systems made for cold, snowy climates." },
    ],
  },
];

export const getLocation = (slug) => LOCATIONS_DATA.find((c) => c.slug === slug);
export const PRIMARY_LOCATIONS = LOCATIONS_DATA.filter((c) => c.primary);
export const SECONDARY_LOCATIONS = LOCATIONS_DATA.filter((c) => !c.primary);
